export class OrderpatienthistoryModel
{
    PatienthistoryId : number;
    OrderId : number;
    OrgId : number;
    HistoryType:string;
    ImageCount : number;
    FilePath : string;
    Description : string;
    PacsHistorySendStatus : string;
    CreatedByName: string;
    CreatedOn : Date;
    UpdateBy: string;
    LastModifiedBy: number;
    LastModifiedOn : Date;
}
